import { useReactiveHasPermission } from '../../Permissions/hooks/useHasPermission';

interface TerritoryPermissions {
  hasCreatePromptPermission: boolean;
  hasCreatePostPermission: boolean;
}

export const hasPermissionToCreateTerritoryPostsAndPrompts = (territoryId?: string): TerritoryPermissions => {
  const hasPermission = useReactiveHasPermission();

  const hasCreatePromptPermission =
    hasPermission('GLOBAL_CAN_MANAGE_ARTICLE_TERRITORY') ||
    (!!territoryId && hasPermission('TERRITORY_CAN_CREATE_PROMPT', territoryId));
  const hasCreatePostPermission =
    hasPermission('GLOBAL_CAN_MANAGE_ARTICLE_TERRITORY') ||
    (!!territoryId && hasPermission('TERRITORY_CAN_CREATE_POST', territoryId));

  return {
    hasCreatePromptPermission,
    hasCreatePostPermission,
  };
};
